import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getFlatsStep } from "../api/api";

export const getFlatsInfo = createAsyncThunk(
	'visual/getFlatsInfo',
	async (complexId, floorNumber) => {
		const response = await getFlatsStep(complexId, floorNumber);
		return response;
	}
);

const initialState = {
	step: 'floors',
	activeFloor: '',
	floors: {},
};

export const visualSlice = createSlice({
	name: 'visual',
	initialState,
	reducers: {
		changeStep: (state, action) => {
			state.step = action.payload;
		},
		changeActiveFloor: (state, action) => {
			state.activeFloor = action.payload;
		},
        changeActiveSection: (state, action) => {
			state.activeSection = action.payload;
		},
	},
	extraReducers: {
		[getFlatsInfo.fulfilled]: (state, action) => {
			state.floors = action.payload.floor.levels;
		}
	}
});

export const {changeStep, changeActiveFloor, changeActiveSection} = visualSlice.actions;

export default visualSlice.reducer;
